import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import {Link} from 'react-router-dom';
const { SubMenu } = Menu;
class SiderLayout extends Component {
    render() {
        const { path, usuario } = this.props
        if (usuario) {
            if (usuario.user_permissions && usuario.user_permissions.length > 0) {
                let permisoUsuario=usuario.user_permissions[0].codename
                if (permisoUsuario==="cajero"){
                    return (
                        <Menu theme="light" mode="inline" style={{ textAlign: 'left' }}>
                            <Menu.Item key="2">
                                <Icon type="contacts" />
                                <span className="nav-text">Clientes</span>
                                <Link to={`${path.path}/clientes`} />
                            </Menu.Item>
                        </Menu>
                    );  
                }
                if(permisoUsuario==="etiquetas"){
                    return (
                        <Menu theme="light" mode="inline" style={{ textAlign: 'left' }}>
                            <Menu.Item key="1">
                            <Icon type="read" />
                            <span className="nav-text">Productos</span>
                            <Link to={`${path.path}/productos`} />
                        </Menu.Item>
                        </Menu>
                    );  
                }
                else {
                    return (
                        <Menu theme="light" mode="inline" defaultSelectedKeys={['sub2']} defaultOpenKeys={['sub1']} style={{ textAlign: 'left' }}>
                            {usuario.user_permissions.map((permiso, key) => (
                                <Menu.Item key={key}>
                                    <Icon type="contacts" />
                                    <span className="nav-text">Ordenes {permiso.codename}</span>
                                    {/* <Link to={`${path.path}/${permiso.codename}`} /> */}
                                    <Link to={`${path.path}/ordenes/pendientes`} />
                                </Menu.Item>
                            ))}
                            {usuario.user_permissions.map((permiso, key) => (
                                permiso.codename==="surtidor"?
                                    <Menu theme="light" mode="inline" style={{ textAlign: 'left' }} key={key}>
                                        <Menu.Item key="2">
                                            <Icon type="contacts" />
                                            <span className="nav-text">Clientes</span>
                                            <Link to={`${path.path}/clientes`} />
                                        </Menu.Item>
                                    </Menu> : null
                               
                            ))}
                            <SubMenu
                                key="sub2"
                                title={
                                    <span style={{ color: "#fff" }}>
                                        <Icon type="database" />
                                        <span>Recursos</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="sub2">
                                    <Icon type="book" />
                                    <span style={{ fontSize: 14 }}>Recursos</span>
                                    <Link to={`${path.path}/recursos`} />
                                </Menu.Item>
                                <Menu.Item key="sub3">
                                    <Icon type="video-camera" />
                                    <span style={{ fontSize: 14 }}>Manuales</span>
                                    <Link to={`${path.path}/manuales`} />
                                </Menu.Item>
                            </SubMenu>
                        </Menu>
                    );
                }
            }
            else if (usuario.is_superuser) {
                return (
                    <Menu theme="light" mode="inline" defaultSelectedKeys={['sub2']} defaultOpenKeys={['sub1']} style={{ textAlign: 'left' }}>
                        <SubMenu
                            key="sub1"
                            title={
                                <span>
                                    <Icon type="database" />
                                    <span>Ordenes</span>
                                </span>
                            }
                        >
                            <Menu.Item key="sub2">
                                <Icon type="warning" />
                                <span style={{ fontSize: 14 }}>Pendientes de aprobar </span>
                                <Link to={`${path.path}/ordenes/pendientes`} />
                            </Menu.Item>
                            <Menu.Item key="sub3">
                                <Icon type="folder-open" />
                                <span style={{ fontSize: 14 }}>Historial</span>
                                <Link to={`${path.path}/ordenes/historial`} />
                            </Menu.Item>
                            {/* <Menu.Item key="sub4">
                            <Icon type="bars"/>
                           <span style={{fontSize:14}}>Lista de precios</span>
                            <Link to={`${path.path}/ordenes/precios`}/>
                        </Menu.Item> */}
                        </SubMenu>
                        <Menu.Item key="2">
                            <Icon type="contacts" />
                            <span className="nav-text">Clientes</span>
                            <Link to={`${path.path}/clientes`} />
                        </Menu.Item>
                        <Menu.Item key="3">
                            <Icon type="read" />
                            <span className="nav-text">Catalogo</span>
                            <Link to={`${path.path}/catalogo`} />
                        </Menu.Item>
                        <Menu.Item key="4">
                            <Icon type="read" />
                            <span className="nav-text">Productos</span>
                            <Link to={`${path.path}/productos`} />
                        </Menu.Item>
                        <Menu.Item key="5">
                            <Icon type="team" />
                            <span className="nav-text">Usuarios</span>
                            <Link to={`${path.path}/usuarios`} />
                        </Menu.Item>
                        <SubMenu
                            key="sub2"
                            title={
                                <span style={{ color: "#fff" }}>
                                    <Icon type="database" />
                                    <span>Recursos</span>
                                </span>
                            }
                        >
                            <Menu.Item key="sub4">
                                <Icon type="book" />
                                <span style={{ fontSize: 14 }}>Recursos</span>
                                <Link to={`${path.path}/recursos`} />
                            </Menu.Item>
                            <Menu.Item key="sub5">
                                <Icon type="video-camera" />
                                <span style={{ fontSize: 14 }}>Manuales</span>
                                <Link to={`${path.path}/manuales`} />
                            </Menu.Item>
                        </SubMenu>


                    </Menu>
                );

            }

        }

        else {
            return (
                <Menu theme="light" mode="inline" defaultSelectedKeys={['sub2']} defaultOpenKeys={['sub1']} style={{ textAlign: 'left' }}>
                    <Menu.Item key="5">
                        <Icon type="folder" />
                        <span className="nav-text">Recursos</span>
                        <Link to={`${path.path}/recursos`} />
                    </Menu.Item>
                </Menu>
            );
        }

    }
}

export default SiderLayout;